import React from 'react'
import HeaderScout from '../components/Header/ScoutLoggedinHeader/HeaderScout'
import HeaderScoutMobile from '../components/Header/HeaderScoutMobile/HeaderScoutMobile'
import FooterScoutMobile from '../components/Footer/FooterScoutMobile/FooterScoutMobile'

const ScoutLayout = ({ children }) => {
    return (
        <div className='scout-layout'>
            {/* <div className="d-none d-lg-block header-scout-wrap"> */}
            <HeaderScout />
            {/* </div> */}
            {/* <div className="d-block d-lg-none header-scout-wrap">
                <HeaderScoutMobile />
            </div> */}
            <div className="scout-main">
                <div className="scout-content">{children}</div>
            </div>
            {/* <div className="d-block d-lg-none footer-scout-wrap">
                <FooterScoutMobile />
            </div> */}
        </div>
    )
}

export default ScoutLayout